export const STRING_MENU = {
  MANAGEMENT_BRAND: "QUẢN LÝ THƯƠNG HIỆU",
  MANAGEMENT_COMPANY: "QUẢN LÝ CÔNG TY",
  DASHBOARD: "DASHBOARD",
  ADMIN: "QUẢN LÝ QUẢN TRỊ VIÊN",
  MANAGEMENT_PROMOTION_CAMPAIGN: "QUẢN LÝ KHUYẾN MÃI",
  MANAGEMENT_BANNER: "QUẢN LÝ BANNER",
  MANAGEMENT_APP_VERSION: "QUẢN LÝ VERSION",
};

export const STRING_SUB_MENU = {
  ADMIN: "Danh sách quản trị viên",
  BRAND: "Danh sách thương hiệu",
  COMPANIES: "Danh sách công ty",
  APP_VERSION: "Danh sách version",
  PROMOTION_CAMPAIGN_TYPE: "Danh sách loại khuyến mãi",
  BRAND_ASSIGN_PROMOTION: "Gán khuyến mãi",
  BRAND_CAMPAIGNS: "Danh sách thương hiệu đã gán khuyến mãi",
  LIST_BANNER: "Danh sách banner",
};
